<div class="py-1">
  <py-badge
    *ngIf="!toggleBadge; else templateToggle"
    [selectable]="true"
    [disabled]="disabled"
    [selected]="picked"
    (click)="select()"
    [large]="true"
    [tag]="true"
    >{{ label }}</py-badge
  >
  <ng-template #templateToggle>
    <py-badge
      [selectable]="true"
      [disabled]="disabled"
      [selected]="picked"
      (click)="select()"
      [tag]="true"
      [large]="true"
      [type]="badgeType.Success"
      >{{ label }}</py-badge
    >
  </ng-template>
</div>
